export default __webpack_public_path__ + "static/media/loaded-bee03@4x.9ab16536.jpeg";